import React, { memo, useContext } from 'react';

import IvrTreeContext from 'src/presentation/components/pages/ivr/components/ivrTree/ivrTreeContext';
import useDragNode from 'src/presentation/components/pages/ivr/components/ivrTree/hooks/useDragNode';
import { DraggableContainer } from 'src/presentation/components/pages/ivr/components/ivrTree/ivrTreeLayout';
import { IvrEditorContext } from 'src/presentation/components/pages/ivr/IvrEditor';
import { START_NODE_ID } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';
import { TextNode } from './optionNode';

const StartNode = ({ x, y, width = 0, height = 0, transform, highlighted, selected, node }) => {
  const { nodeClick } = useContext(IvrTreeContext);
  const { invalidFormList } = useContext(IvrEditorContext);

  const nodeIsInvalid = invalidFormList.includes(START_NODE_ID);
  const click = () => nodeClick && nodeClick(node);
  const { setNodeRef } = useDragNode({ nodeId: START_NODE_ID, x, y, onClick: click });

  return (
    <DraggableContainer
      className={`node${selected ? ' selected' : ''}`}
      transform={`translate(${x},${y})`}
      ref={setNodeRef}
      data-aid={`ivrTreeNode-${START_NODE_ID}`}
      nodeIsInvalid={nodeIsInvalid}
    >
      <TextNode
        className="text-node"
        id={START_NODE_ID}
        text="Start"
        transform={transform}
        width={width}
        height={height}
        highlighted={highlighted}
        nodeIsInvalid={nodeIsInvalid}
        selected={selected}
        rx={24}
        fontSize={13}
        node={node}
      />
    </DraggableContainer>
  );
};

export default memo(StartNode);
